import {
  core_v1_DataSource,
  coreV1ReplaceDataSourceMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { setClientOfOrigin } from '@/utils/setClientOfOrigin';

export const useUpdateDataSource = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: ({
      data,
      name,
    }: {
      data: core_v1_DataSource;
      name: string;
    }) => {
      const dataWithClientOrigin = setClientOfOrigin(data);
      return coreV1ReplaceDataSourceMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: dataWithClientOrigin, path: { workspace, name } });
    },
  });
};
